import { NgModule } from '@angular/core';
import { FnDatePickerComponent } from './fn-date-picker.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { FoundationModule } from '../../foundation.module';

export * from './fn-date-picker.component';
export * from './fn-date.model';

/** 
 * Exports the required FnDatePickerComponent to create datePicker Element
 * making them available for import by NgModules that import this module.
 */

@NgModule({
	declarations: [FnDatePickerComponent],
	imports: [
		CommonModule,
		FormsModule,
		MatDatepickerModule,
		MatNativeDateModule,
		FoundationModule,
	],
	exports: [FnDatePickerComponent],
})
export class FnDatePickerModule {}
